import {
  forwardRef,
  useImperativeHandle,
  useRef,
  useCallback,
  useState,
  useMemo,
  useEffect,
} from "react";

//import CommonDateRangePicker from "../utils/CommonDateRangePicker";
//import CustomDateRange from "../../utils/CustomDateRange";
import CAgGrid from "./CAgGrid";
import { FollowUpOrders } from "../services/followUpService";
import { GetUserWithRole } from "../services/incentive";
import CDropdown from "./CDropdown";
import CustomDateRange from "../utils/CustomDateRange";
import CommonGridHeader from "./CommonGridHeader";

const today = new Date().toISOString().split("T")[0];

const CFolloUpOrders = forwardRef(
  (
    {
      columnDefs,
      h4,
      reOrder = false,
      isComplete = null,
      isringing = null,
      isDeny = null,
      IsAdmin = false,
      IsTeam = false,
      IsPunch = false,
      userId: propUserId,
    },
    ref
  ) => {
    const abortRef = useRef(null);
    const gridRef = useRef(null);
    const [users, setUsers] = useState([]);
    const [userId, setUserId] = useState(null);

    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

//implement header fields
const defaultFields = useMemo(
  () => columnDefs.map(col => col.field),
  [columnDefs]
);
const [selectedFields, setSelectedFields] = useState(defaultFields);
useEffect(() => {
  setSelectedFields(defaultFields);
}, [defaultFields]);

  const handleFieldChange = (field) => {
        setSelectedFields(prev =>
            prev.includes(field)
                ? prev.filter(x => x !== field)
                : [...prev, field]
        );
    };
    const handleReset = () => {
        setSelectedFields(defaultFields);
    };
    const visibleColumnDefs = useMemo(() => {
  return columnDefs.filter(col => selectedFields.includes(col.field));
}, [columnDefs, selectedFields]);
  // end here

    const [dateRange, setDateRange] = useState({
      startDate: today,
      endDate: today,
    });

    const [search, setSearch] = useState({
      userId: null,
      followUpStatusId: null,
    });

    useImperativeHandle(ref, () => ({
      refresh() {
        fetchOrders(dateRange.startDate, dateRange.endDate);
      },
    }));

    useEffect(() => {
      if (propUserId) {
        setUserId(propUserId);
      } else {
        const id = Number(localStorage.getItem("userid"));
        if (id) setUserId(id);
      }
    }, [propUserId]);

    const fetchUsers = useCallback(async () => {
      if (!IsAdmin) return;

      try {
        setErrors({});

        const response = await GetUserWithRole();

        if (response?.success) {
          const teamLeaders = (response.data ?? []).filter((x) =>
            x.name.includes("(Team Leader)")
          );
          setUsers([
            {
              id: 0,
              name: "All",
            },
            ...teamLeaders,
          ]);
        } else {
          setUsers([]);
          setErrors({
            form: response?.message || "Unable to fetch users.",
          });
        }
      } catch (err) {
        console.error(err);
        setUsers([]);
        setErrors({
          form:
            err?.response?.data?.message ||
            "Unable to fetch users.",
        });
      }
    }, [IsAdmin]);

    useEffect(() => {
      fetchUsers();
    }, [fetchUsers]);

    const mapOrders = useCallback((data = []) => {
      return data.map((item) => ({
        id: item.assignId,
        orderId: item.id,
        orderType:item.orderType,
        customerName: `${item.firstName ?? ""} ${item.lastName ?? ""}`.trim(),
        wayBill: item.wayBill,
        courierStatus: item.courierStatus,
        courier: item.courier,
        mobile: item.mobile,
        email: item.email,
        city: item.city,
        state: item.state,
        pincode: item.postalCode,
        totalAmount: item.gTotal,
        paymentType: item.payment?.name,
        dateCreated: item.dateCreated
          ? new Date(item.dateCreated).toLocaleString()
          : "",
        deliveredDate: item.deliveredDate,
        teleCaller: item.teleCaller ?? "",
        diseaseName: item.issueDisease?.name,
        remarks: item.remarks,
        product:
          item.getOrderItemDtos
            ?.map(
              (x) =>
                `${x.productName} (Qty: ${x.quantity ?? 0}, Price: ${x.priceAtPurchase ?? 0})`
            )
            .join(", ") || "",
        totalItem: item.getOrderItemDtos?.length ?? 0,
      }));
    }, []);

    const fetchOrders = useCallback(
      async (startDate, endDate) => {
        try {
          setLoading(true);

          if (abortRef.current) {
            abortRef.current.abort();
          }

          const controller = new AbortController();
          abortRef.current = controller;


          // let selectedUserId = userId;

          // if (IsPunch) {
          //   selectedUserId = null;
          // } else if (IsAdmin && search.userId) {
          //   selectedUserId = search.userId;
          // }

          let selectedUserId = userId;

          if (IsPunch) {
            selectedUserId = null;
          } else if (IsAdmin) {
            selectedUserId = search.userId === 0
              ? null
              : search.userId;
          }

          const statusId = IsPunch
            ? 3
            : search.followUpStatusId;

          const response = await FollowUpOrders(
            reOrder,
            selectedUserId,
            statusId,
            isComplete,
            isringing,
            isDeny,
            startDate,
            endDate,
            search.followUpStatusId,
            {
              signal: controller.signal,
            }
          );

          setRowData(mapOrders(response?.data ?? []));
        } catch (error) {
          if (error.name !== "AbortError") {
            console.error(error);
            setRowData([]);
          }
        } finally {
          setLoading(false);
        }
      },
      [
        userId,
        IsAdmin,
        IsPunch,
        reOrder,
        isComplete,
        isringing,
        isDeny,
        search.userId,
        search.followUpStatusId,
        mapOrders,
      ]
    );

    useEffect(() => {
      if (!userId) return;

      fetchOrders(dateRange.startDate, dateRange.endDate);

      return () => abortRef.current?.abort();
    }, [userId, dateRange, fetchOrders]);

    const handleInputChange = (field, value) => {
      setSearch((prev) => ({
        ...prev,
        [field]: value,
      }));
    };

    const handleTeamChange = (e) => {
      const value = e.target.value ? Number(e.target.value) : null;

      handleInputChange("userId", value);
    };

    const handleSearch = () => {
      fetchOrders(dateRange.startDate, dateRange.endDate);
    };

    const handleDateChange = ({ startDate, endDate }) => {
      setDateRange({
        startDate,
        endDate,
      });
    };

    const defaultColDef = useMemo(
      () => ({
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true,
      }),
      []
    );

    return (
      <>
        <h4>{h4}</h4>

<CommonGridHeader
    fields={columnDefs.map(col => ({
        key: col.field,
        label: col.headerName
    }))}
    selectedFields={selectedFields}
    onFieldChange={handleFieldChange}
    onReset={handleReset}
/>

        <div className="row g-3 align-items-end mb-3">
          {!IsPunch && (
            <div className="col-md-3">
              {/* <CommonDateRangePicker
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                onApply={handleDateChange}
              /> */}
              <CustomDateRange
                startDate={dateRange.startDate}
                endDate={dateRange.endDate}
                onChange={handleDateChange}
              />
            </div>
          )}
          {IsAdmin && (
            <div className="col-md-3">
              <CDropdown
                label="Select Team"
                value={search.userId ?? ""}
                options={users}
                optionLabel="name"
                optionValue="id"
                firstOption="Select Team"
                onChange={handleTeamChange}
              />
            </div>
          )}

          {IsAdmin && (
            <div className="col-md-2">
              <label className="form-label">User Id</label>
              <input
                className="form-control"
                value={search.userId ?? ""}
                readOnly
              />
            </div>
          )}

          {!IsPunch && (
            <div className="col-md-2">
              <label className="form-label">
                Follow Up Status
              </label>

              <select
                className="form-select"
                value={search.followUpStatusId ?? ""}
                onChange={(e) =>
                  handleInputChange(
                    "followUpStatusId",
                    e.target.value
                      ? Number(e.target.value)
                      : null
                  )
                }
              >
                <option value="">Pending</option>
                <option value="1">Interested</option>
                <option value="2">Not Interested</option>
                <option value="4">Ringing</option>
                <option value="3">Closed</option>
              </select>
            </div>
          )}
          {!IsPunch && (
            <div className="col-md-2">
              <button
                className="btn btn-primary w-100"
                onClick={handleSearch}
              >
                Search
              </button>
            </div>
          )}
        </div>

        {errors.form && (
          <div className="alert alert-danger">
            {errors.form}
          </div>
        )}

        <div className="mb-3">
          <strong>Total Orders :</strong> {rowData.length}
        </div>

        <CAgGrid
          ref={gridRef}
          rowData={rowData}
          columnDefs={visibleColumnDefs}
          defaultColDef={defaultColDef}
          loading={loading}
          pagination
          paginationPageSize={20}
          rowSelection={{
            mode: "singleRow",
            checkboxes: false,
            headerCheckbox: false,
            enableClickSelection: true,
          }}
          height="400px"
          overlayNoRowsTemplate="<span>No orders found.</span>"
        />
      </>
    );
  }
);

export default CFolloUpOrders;